import React  from 'react';
import styled from 'styled-components';
import { BrowserRouter, Route } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


import Home from './Pages/Home';
import About from './Pages/About';
import Services from './Pages/Services';
import Architecture from './Pages/Architecture';
import Software from './Pages/Software';
import Data from './Pages/Data'
import Preloader from './components/Preloader';
import Header from './components/Header';

toast.configure();

const StyledContent = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 80vh;
  width: 100%;
`;

function App() {
  window.localStorage.setItem('pdfLoaded', 'false');
  return (
    <BrowserRouter>
      <Header />
      <AnimatePresence exitBeforeEnter initial={false}>
        <StyledContent
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <Preloader>
            <Route path="/" exact component={Home} />
            <Route path="/about" component={About} />
            <Route path="/services" component={Services} />
            <Route path="/architecture" component={Architecture} />
            <Route path="/software" exact component={Software} />
            <Route path="/software/:id" component={Software} />
            <Route path="/data" exact component={Data} />
            <Route path="/data/:id" component={Data} />
          </Preloader>
        </StyledContent>
      </AnimatePresence>
    </BrowserRouter>
  );
}

export default App;
